<div class="page-layout blank p-12" fusePerfectScrollbar>
    <div class="w-100-p h-100-p" *ngIf="!isLoading">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-8">
            <div>
                <h4>Agendamento</h4>
            </div>

            <div class="mt-12" fxLayoutalign="end">
                <button
                    id="save"
                    color="accent"
                    (click)="printSummary()"
                    matTooltip="Imprimir"
                    mat-raised-button
                    class="mr-sm-12"
                >
                    Imprimir
                </button>
                <button
                    id="save"
                    color="accent"
                    *ngIf="!['P', 'T'].includes(schedule.situacaoAgenda) && checkIn"
                    (click)="handleCheckIn()"
                    matTooltip="Salvar"
                    mat-raised-button
                    class="mr-sm-12 ml-8"
                >
                    Check-In
                </button>
            </div>
        </div>
        <div id="summaryInfo">
            <mat-form-field class="w-100-p" appearance="outline">
                <mat-label>Paciente</mat-label>
                <input
                    type="text"
                    placeholder="Nome"
                    aria-label="Number"
                    matInput
                    readonly
                    [value]="schedule.paciente.nomePaciente"
                />
            </mat-form-field>
            <mat-form-field class="w-100-p" appearance="outline">
                <mat-label>Médico</mat-label>
                <input
                    type="text"
                    placeholder="Nome"
                    aria-label="Number"
                    matInput
                    readonly
                    [value]="professional.name"
                />
            </mat-form-field>
            <mat-form-field class="w-100-p" appearance="outline">
                <mat-label>Data</mat-label>
                <input
                    type="text"
                    placeholder="Nome"
                    aria-label="Number"
                    matInput
                    readonly
                    [value]="
                        schedule.dataAgenda
                            | date
                                : 'EEEE, d MMMM, y' +
                                      ' - ' +
                                      schedule.horaAgenda.substring(0, 5)
                    "
                />
            </mat-form-field>
            <mat-form-field
                class="w-100-p"
                appearance="outline"
                *ngIf="insurance"
            >
                <mat-label>Convênio</mat-label>
                <input
                    type="text"
                    placeholder="Nome"
                    aria-label="Number"
                    matInput
                    readonly
                    [value]="insurance.name"
                />
            </mat-form-field>
            <mat-form-field
                class="w-100-p"
                appearance="outline"
                *ngIf="schedule.nomeEspecialidade"
            >
                <mat-label>Especialidade</mat-label>
                <input
                    type="text"
                    placeholder="Nome"
                    aria-label="Number"
                    matInput
                    readonly
                    [value]="schedule.nomeEspecialidade"
                />
            </mat-form-field>
            <mat-form-field class="w-100-p" appearance="outline">
                <mat-label>Serviço</mat-label>
                <input
                    type="text"
                    placeholder="Nome"
                    aria-label="Number"
                    matInput
                    readonly
                    [value]="schedule.nomeProcedimento"
                />
            </mat-form-field>

            <mat-form-field class="w-100-p" appearance="outline">
                <mat-label>Celular</mat-label>
                <input
                    type="text"
                    placeholder="Nome"
                    aria-label="Number"
                    matInput
                    readonly
                    [value]="
                        schedule.paciente.telefoneCelular | mask: '(00) 0 0000-0000'
                    "
                />
            </mat-form-field>

            <mat-form-field class="w-100-p" appearance="outline">
                <mat-label>Telefone</mat-label>
                <input
                    type="text"
                    placeholder="Nome"
                    aria-label="Number"
                    matInput
                    readonly
                    [value]="
                        schedule.paciente.telefone | mask: '(00) 0000-0000'
                    "
                />
            </mat-form-field>

            <p
                *ngIf=" schedule.situacaoAgenda == 'P' || schedule.situacaoAgenda == 'T'"
                style="text-align: center"
            >
                Presença confirmada!
            </p>
        </div>
    </div>
</div>
